export default "__VITE_ASSET__afa84488__"